import React from 'react';
import { AuthenticatedTemplate } from '@azure/msal-react';
import { Page } from 'components/layout';
import { Fedsa } from 'pages/Fedsa';
import { AboutPage } from 'pages/About/about';

const Home = () => (
  <Page>
    <AuthenticatedTemplate>
      <AboutPage />
    </AuthenticatedTemplate>
  </Page>
);

export default Home;
